// extracted by mini-css-extract-plugin
module.exports = {"backToTop":"backtotop_backToTop__F2zMf","isVisible":"backtotop_isVisible__AM1s5"};